// config.js
const baseURL = 'https://app.rasutrip.com/api/v1';
export default baseURL;
